<template>
  <div>
    <el-form
      :model="form"
      :rules="rules"
      label-position="top"
      class="form-area"
    >
      <el-form-item label="统一社会信用代码" prop="creditCode" required>
        <!-- <el-input
          v-model="form.creditCode"
          placeholder="请输入社会信用代码"
          clearable
        /> -->
        <el-select v-model="form.creditCode" placeholder="请选择社会信用代码">
          <el-option
            v-for="item in failedList"
            :key="item.aiAcount"
            :label="item.realName + item.aiAcount"
            :value="item.aiAcount"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-row :gutter="20" class="end_flex">
          <el-col :span="6">
            <el-button
              type="primary"
              icon="el-icon-thumb"
              @click="generateLink"
              style="width: 100%"
              :loading="isLoadingLink"
              clearable
            >
              查询打款结果
            </el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              icon="el-icon-search"
              @click="checkResult"
              style="width: 100%"
              :loading="isLoadingResult"
            >
              查询开户信息
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 打款信息  -->
      <div v-if="payInfo.bank">
        <el-divider content-position="left">打款信息 </el-divider>
        <div class="pay_info_item" style="color:red;margin-bottom:10px;">
          <span>重要提示：</span>
          汇款金额作为企业实名专用，不做退还，无法开发票!
        </div>
        <!-- 开户行 -->
        <div class="pay_info_item">
          <span>开户行：</span>
          {{ payInfo.bank }}
        </div>
        <!-- 对公账户 -->
        <div class="pay_info_item">
          <span>对公账户：</span>
          {{ payInfo.bankAccount }}
        </div>
        <!-- 账户名称 -->
        <div class="pay_info_item">
          <span>账户名称：</span>
          {{ payInfo.bankAccountName }}
        </div>
        <!-- 打款金额 -->
        <div class="pay_info_item">
          <span>打款金额：</span>
          {{ payInfo.amount }}
        </div>
        <!-- 一键复制 -->
        <div class="pay_info_item_copy">
          <el-button @click="copyLink">
            一键复制
          </el-button>
        </div>
      </div>

      <!-- 签署结果 -->
      <el-divider v-if="signResult" content-position="left"
        >签署结果</el-divider
      >
      <el-card v-if="signResult" shadow="always" class="result-card">
        <p>
          <strong>签署状态：</strong
          >{{ signResult === 1 ? "已签署" : "未签署" }}
        </p>
      </el-card>
    </el-form>
  </div>
</template>
<script>
import {
  reversetransfer,
  reversetransfercheck,
  authfailedlist
} from "@/api/category";
export default {
  data() {
    return {
      payInfo: {
        serialNo: "",
        bank: "",
        bankAccount: "",
        bankAccountName: "",
        amount: ""
      },
      dialogVisible: false,
      form: {
        creditCode: ""
      },
      rules: {
        creditCode: [
          { required: true, message: "请输入统一社会信用代码", trigger: "blur" }
        ]
      },
      signUrl: "",
      signResult: null,
      isLoadingLink: false,
      isLoadingResult: false,
      failedList: []
    };
  },
  mounted() {
    this.getAuthfailedlist();
  },
  methods: {
    getAuthfailedlist() {
      authfailedlist({}).then(res => {
        console.log("authfailedlist", res);
        if (res.status === 0) {
          this.failedList = res.data;
        }
      });
    },
    async generateLink() {
      if (!this.form.creditCode) return this.$message.error("请选择信用代码");
      try {
        this.isLoadingLink = true;
        const res = await reversetransfercheck({
          idcard: this.form.creditCode,
          userType: 1
        });
        this.isLoadingLink = false;
        console.log("========111", res);
        if (res.status === 0 && res.msg !== "调用爱签返回结果失败") {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }

        // if (res.code === 0) {
        //   this.signUrl = res.data.signUrl;
        // } else {
        //   this.$message.error(res.msg);
        // }
      } catch {
        this.isLoadingLink = false;
        // this.$message.error("网络异常请重试");
      }
    },
    async checkResult() {
      if (!this.form.creditCode) return this.$message.error("请输入信用代码");
      try {
        this.isLoadingResult = true;
        const res = await reversetransfer({
          idCardNo: this.form.creditCode,
          userType: 1
        });
        this.isLoadingResult = false;
        console.log("========", res);
        if (res.status === 0 && res.data.bank) {
          this.payInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch {
        this.isLoadingResult = false;
      }
    },
    copyLink() {
      const textarea = document.createElement("textarea");
      textarea.value = `
      重要提示:汇款金额作为企业实名专用，不做退还，无法开发票!
        开户行:${this.payInfo.bank}
      对公账户:${this.payInfo.bankAccount}
      账户名称:${this.payInfo.bankAccountName}
      打款金额:${this.payInfo.amount}`;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    }
  }
};
</script>

<style scoped lang="scss">
.pay_info_item_copy {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.pay_info_item {
  font-size: 15px;
  margin-bottom: 3px;
  span {
    font-weight: bold;
    display: inline-block;
    width: 80px;
    text-align: right;
    font-size: 15px;
  }
}
.end_flex {
  display: flex;
  justify-content: flex-end;
}
/* 弹窗标题居中样式 */
.dialog-header {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

/* 表单整体区域 */
.form-area {
  padding: 0 10px;
}

/* 签署链接区域样式 */
.link-area {
  background: #f5f7fa;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  div {
    width: 520px;
    display: flex;
    flex-wrap: wrap;
    word-break: break-all; /* 激进换行，适合长URL */
    overflow-wrap: break-word; /* 备用方案，优先在单词边界换行 */
    white-space: normal; /* 覆盖默认样式，允许换行 */
  }
}

/* 签署结果卡片样式 */
.result-card {
  font-size: 14px;
  line-height: 1.8;
  background-color: #f9f9f9;
}
</style>
